import './SolutionDetails.css'
import TopicTitlePath from '../components/parts/TopicTitlePath';
import { useSearchParams } from 'react-router-dom';
import { useEffect } from 'react';
import parse from 'html-react-parser';
import NotFound from '../components/NotFound';
import { useSolution } from '../api/useSolution';
import Loading from '../components/parts/Loading';
import MenuList from '../components/parts/MenuList';
import { Space, HStack } from '../components/parts/SharedLayout';
import { mediaQuery, useMediaQuery } from '../hooks/useMediaQuery';
import { SolutionPoint } from './SolutionDetails';
import Category from '../components/parts/Category';

export default function SolutionPreview() {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('preview_token');
    const { solutionDetails, getPreview, isLoading } = useSolution();
    const isSP = useMediaQuery(mediaQuery.sp);

    useEffect(() => {
        if (token) {
            getPreview(token);
        }
    }, [getPreview, token]);

    if (isLoading) {
        return (
            <Loading />
        );
    }

    if (!solutionDetails.details.topics_id) {
        return (
            <>
                <NotFound link='/solution'>ソリューションに戻る</NotFound>
            </>
        );
    }

    return (
        <>
            {
                <div>
                    <TopicTitlePath topicMain={solutionDetails.details.subject} topicSub='SOLUTION' topicPath={[{ name: '株式会社はばたーく', link: '/' }, { name: 'ソリューション', link: '/solution' }, { name: solutionDetails.details.subject, link: `/solution-details/${solutionDetails.details.topics_id}` }]} />
                    <div className='topic-1'>
                        <div className='subject'>{solutionDetails.details.subject}</div>
                        {
                            solutionDetails.details.subtitle &&
                            <div className='subtitle'>{solutionDetails.details.subtitle}</div>
                        }
                        <img className='eyecatch' src={solutionDetails.details.image.url_org} alt="" />
                        <div className='date-and-category'>
                            {
                                solutionDetails.details.ymd &&
                                <div className='date en-font'>{solutionDetails.details.ymd.split('-').join('.')}</div>
                            }
                            <HStack className='sol-tag-area'>
                                {
                                    solutionDetails.details.categories.length > 0 &&
                                    solutionDetails.details.categories.map((category, index) => (
                                        <Category key={index} label={category.label} />
                                    ))
                                }
                            </HStack>
                        </div>
                        
                        {
                            (solutionDetails.details.points.length > 0) &&
                            <>
                                <Space height={`${isSP ? '14vw' : '5vw'}`} />
                                <SolutionPoint points={solutionDetails.details.points} />
                            </>
                        }
                    </div>

                    {solutionDetails.details.menu && <MenuList menu={solutionDetails.details.menu} bgColor={solutionDetails.details.bg_color}/>}

                    <div className='topic-2'>
                        <div className='card' style={{"--section-title-bg": solutionDetails.details.bg_color || "#FFE833",} as React.CSSProperties}>
                            {solutionDetails.details.section && solutionDetails.details.section.map((content, index) => (
                                <div key={index} id={`section_${index + 1}`} className="section-item">
                                    {parse(content)}
                                </div>
                            ))}
                        </div>
                        {
                            (solutionDetails.details.contents1 || solutionDetails.details.contents2 || solutionDetails.details.contents3) &&
                                <div>
                                    <div>{parse(solutionDetails.details.contents1)}</div>
                                    {
                                        (solutionDetails.details.highlights_subject && solutionDetails.details.highlights_text) &&
                                        <div className='white-space flex-col'>
                                            <div className='flex header'>
                                                <div className='yellow-point-m margin-t'></div>
                                                <div className='highlights-subject'>{solutionDetails.details.highlights_subject}</div>
                                            </div>
                                            <div className='highlights-text'>{solutionDetails.details.highlights_text}</div>
                                        </div>
                                    }
                                </div>
                        }
                    </div>
                </div>
            }
        </>
    );
}